import { pointer } from "d3";
import { useEffect, useState } from "react";
import { Tooltip } from "./Tooltip";
import { addDays } from "./utils/timeFormatters"



export function OperacoesExternas({obra, xScale, y, obrasBarHeight, margins} : {obra: any, xScale: any, y: number, obrasBarHeight: number, margins: any}) {

    const [tooltip, setTooltip] = useState<number | null>(null);
    
    const onMouseEnter = (operacaoId : number) => {
        console.log("Received tooltip: ", operacaoId);
        setTooltip(operacaoId);
    }

    const onMouseLeave = () => {
        setTooltip(null);
    }


    const message = (operacao: any, peca: any) => {

        return(<>
                <tspan x={'5'} dy={'1.2em'} fontWeight={'bold'}>{peca.reference}</tspan>
                <tspan x={'5'} dy={'1.2em'}>{operacao.tipo}</tspan>        
                <tspan x={'5'} dy={'1.2em'}>{operacao.observacoes}</tspan>
                <tspan x={'5'} dy={'1.2em'}>{operacao.dataExpedicao}</tspan>
               
                </>)

    }

    const operationType = (operationType: string) => {
        switch(operationType) {
            case 'CNC':
                return 'CNC'
            case 'Controlo e Qualidade':
                return 'C&Q';
            default:
                return `${operationType.slice(0,4)}.`;
        }
    }

    const tooltipWidth = (operacao : any) => {
        return operacao.observacoes.length > 10 ? operacao.observacoes.length * 8 : 120;
    }



    return (<>
        {obra.pecas.map((p: any) => {
                            return (<>
                                {p.operacoes.filter((o: any) => o.isExternal).map((operacao: any) => {

                                        return (<g onMouseEnter={()=> onMouseEnter(operacao.id)} onMouseLeave={onMouseLeave}>
                                            <rect
                                            x={xScale(new Date(operacao.dataExpedicao))}
                                            y={y + margins.top}
                                            width={xScale(addDays(new Date(operacao.dataExpedicao), 1)) - xScale(new Date(operacao.dataExpedicao))}
                                            height={obrasBarHeight}
                                            className={`fill-lime-500 opacity-80 hover:opacity-100`}
                                            stroke={'black'}
                                            strokeWidth={0.5}
                                                                               
                                        />
                                        <g transform={`translate(${xScale(new Date(operacao.dataExpedicao)) +2}, ${y + margins.top + 15})`}>
                                            <text className="text-sm font-bold">{operationType(operacao.tipo)}</text>
                                        </g>
                                        
                                        {tooltip === operacao.id ? <Tooltip multiline height={100} width={tooltipWidth(operacao)} size={'sm'} x={xScale(addDays(new Date(operacao.dataExpedicao),2))} y={y + margins.top + 60} message={message(operacao, p)} position={'top'}/> : null}

                                        </g>)

                                        
                                        })
                                        }
                                
                            </>)
                        })}

    </>)



}